import React, { useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import db from '../../db';
import { addDoc, collection, Timestamp } from 'firebase/firestore';


const Appointment = () => {
    const initialFormData = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        appointmentDate: '',
        appointmentTime: '',
        description: '',
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const missingFields = Object.keys(formData).filter((key) => formData[key] === '');

        if (missingFields.length > 0) {
            toast.error(`Please fill these fields: ${missingFields.join(', ')}`);
        } else {
            try {
                const docRef = await addDoc(collection(db, 'Appointment'), {
                    ...formData,
                    appointmentDate: new Date(formData.appointmentDate),
                    // createdAt: Timestamp.now(),
                });

                toast.success('Form submitted successfully!');

                setFormData(initialFormData);
            } catch (error) {
                console.error('Error adding document: ', error);
                toast.error('An error occurred. Please try again later.');
            }
        }
    };


    return (
        <MakeAppointment>
            <Toaster />
            <AppointmentHeading>
                Make Appointment
            </AppointmentHeading>
            <form onSubmit={handleSubmit}>
                <InputRow>
                    <Input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                    <Input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                </InputRow>
                <InputRow>
                    <Input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <Input
                        type="tel"
                        name="phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </InputRow>
                <InputRow>
                    <Input
                        type="date"
                        name="appointmentDate"
                        placeholder="Appointment Date"
                        value={formData.appointmentDate}
                        onChange={handleChange}
                    />
                    <Input
                        type="time"
                        name="appointmentTime"
                        placeholder="Appointment Time"
                        value={formData.appointmentTime}
                        onChange={handleChange}
                    />
                </InputRow>
                <CenteredContainer>
                    <LargeInput
                        name="description"
                        placeholder="Describe what you’re looking for..."
                        value={formData.description}
                        onChange={handleChange}
                    />
                </CenteredContainer>
                <CenteredContainer>
                    <SubmitButton type="submit">Send
                        <svg
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            height="1.5em"
                            width="1.5em"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" />
                            <path d="M10 14L21 3M21 3l-6.5 18a.55.55 0 01-1 0L10 14l-7-3.5a.55.55 0 010-1L21 3" />
                        </svg>

                    </SubmitButton>
                </CenteredContainer>
            </form>
        </MakeAppointment>
    );
};

export default Appointment;

const MakeAppointment = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    flex-direction: column;
`;

const AppointmentHeading = styled.div`
    font-family: Poppins;
    font-size: 48px;
    font-weight: 700;
    line-height: 54px;
    text-align: center;
    margin-top: 50px;
`;

const InputRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
`;

const Input = styled.input`
    width: 372px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
        linear-gradient(0deg, #fcfcfc, #fcfcfc);
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
    box-sizing: border-box;
`;

const LargeInput = styled.textarea`
    width: 760px;
    height: 150px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
        linear-gradient(0deg, #fcfcfc, #fcfcfc);
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 10px;
    box-sizing: border-box;

    @media (max-width: 770px) {
        width: 372px;
      }
`;

const SubmitButton = styled.button`
  width: 150px;
  padding: 16px 20px;
  border-radius: 47px;
  gap: 13px;
  background: rgba(36, 190, 224, 1);
  color: white;
  cursor: pointer;
  border: none;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    flex-shrink: 0; 
    margin-left: 5px;
  }
`;


const CenteredContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
`;

